import { SyntheticEvent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { bomComponentService } from 'bom/services';
import { IComponent, IComponentAutocompleteRequestPayload } from 'bom/types';
import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { IAutocompleteOption } from 'core/types';
import { parseUnicode } from 'core/utils';

interface IProps {
  name?: string;
  label?: string;
  requestPayload?: IComponentAutocompleteRequestPayload;
  required?: boolean;
  disabled?: boolean;
  onChange?: (component: IComponent | null) => void;
}

export const ComponentFormField = ({
  name = 'component',
  label,
  requestPayload: customRequestPayload,
  required = false,
  disabled = false,
  onChange,
}: IProps) => {
  const { t } = useTranslation();

  const { control, errors, setValue } = useFormContext();

  const requestPayload = useMemo(() => {
    return {
      ...customRequestPayload,
      filters: {
        empty: [0],
        ...customRequestPayload?.filters,
      },
    };
  }, [customRequestPayload]);

  const onAddNewComponent = (option: IComponent & IAutocompleteOption) => {
    setValue(name, {
      id: null,
      name: option.title,
    });
  };

  return (
    <FormField
      name={name}
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        control,
        error: errors?.[name],
        label: label || t('labelComponent'),
        placeholder: t('placeholderSelectComponent'),
        getOptions: bomComponentService.getComponentsAutocomplete,
        onNewOption: onAddNewComponent,
        onChange: (_: SyntheticEvent, option: IComponent | null) => {
          if (onChange) {
            onChange(option);
          }
        },
        getLabel: (option: IComponent) => parseUnicode(option.name),
        requestPayload,
        required,
        disabled,
        hasCreateOption: true,
        enabledOnFocus: false,
      }}
    />
  );
};
